module.exports = __webpack_public_path__ + "static/img/case8.15e1ec99.jpg";